import { Component, OnInit, Input, Output, ViewChild, ViewChildren, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ApiService, DialogsService } from '../../custom-material/Services/';
import { BuildingModel, UserModel, IncidentModel } from 'src/app/main/Models/';
import { BuildingChooseComponent } from "../../main/Components/building-choose/building-choose.component";
import { ListComponent } from '../list/list.component';
import { IncidentSheetComponent } from '../incident-sheet/incident-sheet.component';
import { globalData, selectionObserver } from 'src/app/main/Models/global.model';
import { toollist } from './feed.tools';


@Component({
  selector: 'incident-feed',
  templateUrl: './t_feed.component.html',
  styleUrls: ['./feed.component.less']
})
export class FeedComponent implements OnInit, selectionObserver {

  @ViewChild('incList') incidentList: ListComponent;
  @ViewChild('incSheet') incidentSheet: IncidentSheetComponent;

  incidents: Array<IncidentModel> = [];
  sheetIncident: IncidentModel;

  firstOpened:boolean = true;

  get autoSelect()
  {
    if(this.route.snapshot.params['building']!=undefined) {
      return +this.route.snapshot.params['building'];
    } else {
      return 'all';
    }
  }
  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    public gd: globalData,
    private dialog: MatDialog,
    private dialogService: DialogsService) { 
      this.gd.toolService = this;
      this.gd.toollist = toollist;
      this.gd.showChooser = true;
      this.gd.headerTitle = "Remontée d'incidents";
      this.gd.headerIcon = 'sync_problem';
    }
    
  ngOnInit() {
    this.gd.subscribe(this);
    this.buildingsSelectionChanged();
  }

  buildingsSelectionChanged() {
    setTimeout(()=>{
      this.loadAllIncidents(this.gd.selectedBuildingsList);
    }, 100);
  }


  //called when buildingChooser change
  loadAllIncidents(selectedBuildingsList)
  {
    this.incidentList.loadAllIncidents(selectedBuildingsList)
      .then(() => {
        if(this.firstOpened && this.route.snapshot.params['incident']!=undefined) {
         
          if(this.route.snapshot.params['incident'] == 0) this.newIncident();
          else this.incidentList.openIncidentById(+this.route.snapshot.params['incident']);
        
        }
        this.firstOpened = false;
      });
  }

  newIncident()
  {
   if(!this.gd.hasUniqSelectedBuilding) {
      this.dialogService.alert("Veuillez sélectionner l'établissement auquel se rapport l'incident");
      return;
    }
    /*/*
    this.sheetIncident = new IncidentModel({
      gravity: 1, 
      building: this.gd.uniqSelectedBuilding,
      redactor: this.apiService.connectedUser,
      dtwrite: new Date(),
      status: 'Nouveau'
    });
    //*/
    this.router.navigate(['/incidents', this.gd.uniqSelectedBuilding.id, 'new']);
  }

  save(incident: IncidentModel)
  {
    let findIndex = this.incidentList.incidents.findIndex((inc)=>inc.id==incident.id);
    if(findIndex===-1) {
      this.incidentList.incidents.push(incident);
    } else {
      this.incidentList.incidents[findIndex] = incident;
    }
  }


  showIncident(incident:IncidentModel)
  {
    //this.sheetIncident = new IncidentModel(incident);
    this.gd.current = incident;
    this.router.navigate(['/incidents', incident.id]);
  }

  /*closeIncident($event)
  {
    this.sheetIncident = null;
  }*/


  goBack()
  {
    if(this.route.snapshot.params['building']!=undefined) {
      let idBuilding = +this.route.snapshot.params['building'];
      this.router.navigate(['/buildings/'+idBuilding]);
    } else {
      console.warn('cannot go back to building if not in url');
    }
  }
}
